import React from 'react';
import { motion } from 'framer-motion';
import { ServiceCard } from './ServiceCard';
import { premiumServices } from '../../data/customization';
import type { ServiceCategory } from '../../types/customization';

interface ServiceCategoryGroupProps {
  category: ServiceCategory;
  selectedServices: string[];
  onToggle: (serviceId: string) => void;
  currency: string;
  language: string;
}

export const ServiceCategoryGroup: React.FC<ServiceCategoryGroupProps> = ({
  category,
  selectedServices,
  onToggle,
  currency,
  language
}) => {
  const Icon = category.icon;
  const categoryServices = premiumServices.filter(service => 
    category.services.includes(service.id)
  );

  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-gold/10 rounded-lg">
          <Icon className="w-5 h-5 text-gold" />
        </div>
        <div>
          <h3 className="font-semibold text-gold-dark text-lg">{category.name}</h3>
          <p className="text-sm text-black/70">{category.description}</p>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {categoryServices.map(service => (
          <ServiceCard
            key={service.id}
            service={service}
            isSelected={selectedServices.includes(service.id)}
            onToggle={() => onToggle(service.id)}
            currency={currency}
            language={language}
          />
        ))}
      </div>
    </div>
  );
};